import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const PaginationContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	padding: 0 1.6rem;
	background-color: var(--white);
	flex: 1;
	width: 100%;
	height: 6.35rem;

	.enumSelect {
		display: flex;
		justify-content: center;
		align-items: center;

		.enumselect-label {
			min-width: 7.5rem;
			min-height: 3.5rem;
			max-height: 3.5rem;
			padding: 0.35rem 1rem;
		}
	}

	@media ${Breakpoints.mobile} {
		flex: unset;
		height: unset;
	}
`;

export const IconContainer = styled.span`
	display: flex;
	align-items: center;
	border-radius: var(--small-border-radius);

	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
	cursor: pointer;
	color: var(--black);
	justify-content: center;
	height: 2.8rem;
	min-width: 2.6rem;

	:hover {
		> .icon {
			color: var(--alwaysWhiteColor);
		}

		background-color: var(--background-4);
	}

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const PaginationUL = styled.ul`
	display: flex;
	flex: 1;
	justify-content: center;
	list-style-type: none;
	padding: 0 10rem 0 0;

	li {
		padding: 0.5rem 0.8rem;
		height: 2.8rem;
		min-width: 2.6rem;
		text-align: center;
		margin: auto 0.4rem;
		color: var(--black);
		display: flex;
		justify-content: center;
		border-radius: var(--small-border-radius);
		align-items: center;
		font-size: var(--paragraph3-font-size);

		&.dots:hover {
			cursor: default;
			color: var(--secondaryColor);
			background-color: transparent;
		}
		&:hover {
			color: var(--alwaysWhiteColor);
			background-color: var(--background-4);
			cursor: pointer;
		}

		&.selected {
			color: var(--alwaysWhiteColor);
			background-color: var(--secondaryColor);
		}

		&.disabled {
			pointer-events: none;

			&:hover {
				background-color: transparent;
				cursor: default;
			}
		}

		@media ${Breakpoints.mobile} {
			margin: 0;
		}
	}

	@media ${Breakpoints.mobile} {
		padding: 0;
		margin-left: auto;
		flex: unset;

		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: auto;
		}
	}

	body[dir='rtl'] & {
		padding: 0 0 0 10rem;
	}
`;
